"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPropertyRepInfo = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _createProperty = require("ui-addon-upgrades/_core/common/data/upgradeData/transformers/createProperty");

var _fetchOwners = require("ui-addon-upgrades/_core/common/api/fetchOwners");

var _RepTypes = require("ui-addon-upgrades/_core/common/constants/RepTypes");

var _logError = _interopRequireDefault(require("ui-addon-upgrades/_core/common/reliability/logError"));

var tracker = _interopRequireWildcard(require("ui-addon-upgrades/_core/common/eventTracking/tracker"));

var PROPERTY_KEY = 'repInfo';

var getPropertyRepInfo = function getPropertyRepInfo(upgradeData, upgradeSource, props) {
  if (props.allowModal === false) {
    return (0, _createProperty.createProperty)(PROPERTY_KEY, {});
  }

  return (0, _fetchOwners.fetchOwners)().then(function (ownerInfo) {
    var owner = null;

    if (ownerInfo.MARKETING_SALES && ownerInfo.MARKETING_SALES.link) {
      owner = ownerInfo.MARKETING_SALES;
      owner.type = _RepTypes.MARKETING_SALES;
    } else if (ownerInfo.IGS_NURTURING && ownerInfo.IGS_NURTURING.link) {
      owner = ownerInfo.IGS_NURTURING;
      owner.type = _RepTypes.IGS_NURTURING;
    }

    return (0, _createProperty.createProperty)(PROPERTY_KEY, owner);
  }).catch(function (err) {
    (0, _logError.default)('getPropertyRepInfo', err);
    tracker.track('errorInteraction', (0, _extends2.default)({
      name: 'rep fetch failed'
    }, upgradeData));
    return (0, _createProperty.createProperty)(PROPERTY_KEY, {});
  });
};

exports.getPropertyRepInfo = getPropertyRepInfo;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/_core/common/data/upgradeData/transformers/getPropertyRepInfo.js
// module id = 671
// module chunks = 5 6